var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-5"},[_c('h4',[_vm._v("Meus Leads")]),_c('div',{staticClass:"alert alert-info mt-3"},[_vm._v("Disponivel em breve.")]),_c('router-link',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"to":"/afiliado"}},[_vm._v("Voltar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }